import { getCadastroAdicional } from '@/utils/cadastros-adicionais-utils';
import CadastrosAdicionais from '@/enums/cadastros-adicionais';
import { ErpCamposIntegracao } from 'px-business-components';

const hasCamposAdicionaisErpCasaShopping = camposIntegracao => camposIntegracao
  .contaDespesa !== null;

const hasCamposAdicionaisErpFocco = camposIntegracao => camposIntegracao.contaFinanceira !== null;

export const hasCamposAdicionaisErp = (tipoErp, camposIntegracao) => {
  if (tipoErp === ErpCamposIntegracao.keys.CASA_SHOPPING.key) {
    return hasCamposAdicionaisErpCasaShopping(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.FOCCO.key) {
    return hasCamposAdicionaisErpFocco(camposIntegracao);
  }
  return false;
};

const validateCamposErpCasaShopping = (camposIntegracao) => {
  if (!camposIntegracao.contaDespesa) {
    return [false, 'O centro de custo é obrigatório'];
  }
  return [true, null];
};

const validateCamposErpFocco = (camposIntegracao) => {
  if (!camposIntegracao.contaFinanceira) {
    return [false, 'A conta financeira é obrigatória'];
  }
  return [true, null];
};

export const validateCamposErp = (tipoErp, camposIntegracao) => {
  if (tipoErp === ErpCamposIntegracao.keys.CASA_SHOPPING.key) {
    return validateCamposErpCasaShopping(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.FOCCO.key) {
    return validateCamposErpFocco(camposIntegracao);
  }
  return [true, null];
};

export const computeFrom = (tipoErp, cadastrosAdicionais) => {
  if (tipoErp === ErpCamposIntegracao.keys.CASA_SHOPPING.key) {
    return {
      contaDespesa: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_DESPESA.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.FOCCO.key) {
    return {
      contaFinanceira: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_FINANCEIRA.key,
      ),
    };
  }
  return {};
};

export const initialStateCamposErp = (tipoErp) => {
  if (tipoErp === ErpCamposIntegracao.keys.CASA_SHOPPING.key) {
    return {
      contaDespesa: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.FOCCO.key) {
    return {
      contaFinanceira: null,
    };
  }
  return {};
};
